import currencyFormatter from 'currency-formatter';
import { IProductNew } from 'interfaces/product';

export const priceView = (product: IProductNew): string => {
  if (product.price === 0 || !product.price) {
    return 'Gratuito';
  }

  if (product.typeChange === 'A') {
    return `${currencyFormatter.format(product.price, { code: 'BRL', precision: 2 })} recorrente`;
  }

  return currencyFormatter.format(product.price, { code: 'BRL', precision: 2 });
};
